<template>
    <div v-if="isLogged">
        <a href="/logout">Cerrar sesión</a>
    </div>
    <div v-else class="session-buttons-container">
        <a href="#" data-show="login-modal" class="session-button">Iniciar sesión</a>
        <a href="/register" class="register-button session-button">Registrarme</a>
    </div>
  </template>
  
  <script>
  export default {
    name: "session-buttons",
    props: {
      isLogged: {
        type: Boolean,
        required: true,
      },
    },
    mounted() {
      console.log('isLogged prop:', this.isLogged);  // Verifica si se pasa correctamente
    },
  };
  </script>
  
  <style scoped>
  /* Aquí puedes añadir estilos específicos para este componente */
  </style>